<template>
  <div style="position: relative;">
    <DateTimeRow
      class="tender-terms__row"
      :date-min="dateMin"
      :datelabel="$t(datelabel)"
      prop-name="tenderPeriodTo"
      :time-label="$t('Tenders.EndTime')"
      :time-max="timeMax"
      :time-min="timeMin"
      :value.sync="tenderPeriodTo"/>
    <template v-if="isShowPublishBtn">
      <sButton
        class="mb-4"
        data-qa="btn-scheduleAutomaticTenderPublication"
        icon="import"
        icon-class="mr-1"
        small
        type="text"
        @click="scheduleStart">
        {{ plannedPublishing ? $t('Tenders.TurnOffScheduledPublishing') : $t('Tenders.ScheduleAutomaticTenderPublication') }}
      </sButton>
      <DateTimeRow
        v-if="plannedPublishing"
        class="tender-terms__row"
        :date-min="minDatePublish"
        :datelabel="$t('Tenders.PublicationDate')"
        prop-name="scheduledStart"
        :time-label="$t('Tenders.PublicationTime')"
        time-max="18:00:00"
        time-min="08:00:00"
        :value.sync="scheduledStart"/>

      <template v-if="plannedPublishing && $can('set', 'tenderPublicationPlaningMode', 'PUBLISH_WITH_MAIL')">
        <sFormItem
          class="tender-information__content-item"
          prop="previousMailing">
          <div
            slot="label"
            class="h5-headline black--text">
            {{ $t('Tenders.IsPreviousMailing') }}?
          </div>
          <sRadioGroup
            v-model="previousMailing"
            class="mt-2"
            data-qa="tender-previousMailing"
            row>
            <sRadio
              data-qa="tender-previousMailing-yes"
              :label="true">
              {{ $t('Tenders.Yes') }}
            </sRadio>
            <sRadio
              data-qa="tender-previousMailing-no"
              :label="false">
              {{ $t('Tenders.No') }}
            </sRadio>
          </sRadioGroup>
        </sFormItem>

        <sAlert
          class="info-block">
          {{ $t('Tenders.PreviousMailing') }}
          <template slot="desc">
            {{ $t('Tenders.PreviousMailingHint') }}
          </template>
        </sAlert>
      </template>
    </template>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import DateTimeRow from 'components/tenderCreation/block/DateTimeRow.vue'

import textFunctions from 'mixins/textFunctions'

export default {
  name: 'TenderTerms',
  mixins: [ textFunctions ],
  data() {
    return {
      plannedPublishing: false,
      timeMax: '18:00:00',
      timeMin: '08:00:00'
    }
  },
  methods: {
    scheduleStart() {
      if (this.plannedPublishing) {
        this.sendEvent('scheduledStart', null)
      } else {
        const now = new Date()
        now.setHours(now.getHours() + 1)

        this.sendEvent('scheduledStart', this.$_getDateCSharp(now))
      }

      this.plannedPublishing = !this.plannedPublishing
      this.$nextTick(() => {
        this.previousMailing = this.plannedPublishing ? false : null
      })
    },
    formatDateTime(value) {
      if (!value) {
        return null
      }
      if (!/\d{2}:\d{2}:\d{2}$/.test(value)) {
        value += ':00'
      }
      return value
    },
    formatDate(date) {
      const result = {
        dateStr: '',
        timeStr: '',
        dateTimeStr: '',
        date: '',
        time: '',
        dateTime: null,
      }
      try {
        const dateFormat = date ? this.$d(new Date(date)) : ''
        const timeFormat = date ? date.split('T')[1].split(':').slice(0, 2).join(':') : ''/*this.$d(new Date(date), 'time') */

        const dateSplit = date?.split('T') || ['', '']

        result.dateStr = dateFormat
        result.timeStr = timeFormat
        result.dateTimeStr = date ? `${dateFormat} ${timeFormat}:00` : ''
        result.date = dateSplit[0] || ''
        result.time = dateSplit[1] || ''
        result.dateTime = date
      } catch {
        return result
      }
      return result
    },
    sendEvent(prop, value) {
      const result = this.$_.cloneDeep(this.tender)
      result[prop] = value
      this.$emit('update:tender', result)
    }
  },
  computed: {
    ...mapGetters({
      settings: 'getSettings',
    }),
    minDatePublish() {
      return this.$_getDateCSharp(new Date()).split('T')[0]
    },
    previousMailing: {
      get() {
        return this.tender.previousMailing
      },
      set(newValue) {
        const result = {...this.tender}
        result.previousMailing = newValue
        this.$emit('update:tender', result)
      }
    },
    tenderPeriodTo: {
      get() {
        return this.formatDate(this.tender?.tenderPeriodTo)
      },
      set(newValue) {
        let date = new Date(newValue.dateTime)

        let hours = date.getHours()
        const minutes = date.getMinutes()

        // Якщо час ще не встановлено, ставимо 15:00 (мінімальний час)
        if (hours === 0 && minutes === 0) {
          hours = 15
        }

        date = `${newValue.date}T${('000' + hours).slice(-2)}:${('000' + minutes).slice(-2)}:00`

        this.sendEvent('tenderPeriodTo', this.formatDateTime(date))
      }
    },
    scheduledStart: {
      get() {
        return this.formatDate(this.tender.scheduledStart)
      },
      set(newValue) {
        this.sendEvent('scheduledStart', this.formatDateTime(newValue.dateTime))
      }

    },
    hasRequiredAgreement() {
      const statuses = this.settings?.tenderSettings?.tenderAgreeStatus
      const stat = this.tender?.tenderStatusId || this.tender?.tenderStatus?.id
      return !!statuses?.find(item => item.tenderStatus == stat)
    },
    isShowPublishBtn() {
      return !this.tender?.auctionPeriod?.startDate && !this.hasRequiredAgreement && !this.$can('set', 'tenderPublicationPlaningMode', 'DISABLE')
    },
  },
  components: {
    DateTimeRow
  },
  watch: {
    'tender.scheduledStart': {
      immediate: true,
      handler(newValue) {
        const plannedPublishing = !!newValue
        if (plannedPublishing !== this.plannedPublishing) {
          this.plannedPublishing = !!plannedPublishing
        }
      }
    }
  },
  props: {
    tender: {
      type: Object
    },
    datelabel: {
      type: String,
      default: 'Tenders.EndDate'
    },
    dateMin: {
      type: [String, Date],
    },
  },
}
</script>
<style lang="scss" scoped>
.info-block {
  width: 315px;
  position: absolute;
  right: -345px;
  top: 0;
}
.tender-terms__row {
   &.is-required .sFormItem__label:before {
    content: "*";
    color: var(--color-error);
    margin-right: 4px;
  }
}
//.tender-terms__row.is-required .sFormItem__labell:before
</style>
